import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import * as dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/ja';
import 'dayjs/locale/ko';
import 'dayjs/locale/ms-my';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/pt';
import 'dayjs/locale/ru';
import 'dayjs/locale/th';
import 'dayjs/locale/tr';
import 'dayjs/locale/zh-hk';
import 'dayjs/locale/zh-tw';

const LOCALE_MAP = {
	en_US: 'en',
	de_DE: 'de',
	es_ES: 'es',
	es_MX: 'es',
	fr_FR: 'fr',
	it_IT: 'it',
	ja_JP: 'ja',
	ko_KR: 'ko',
	ms_MY: 'ms-my',
	pt_BR: 'pt-br',
	pt_PT: 'pt',
	ru_RU: 'ru',
	th_TH: 'th',
	tr_TR: 'tr',
	zh_HK: 'zh-hk',
	zh_TW: 'zh-tw',
};

function useDayJsInitialization() {
	const locale = useSelector((state) => state.client.data.locale);
	useEffect(() => {
		dayjs.locale(LOCALE_MAP[locale]);
	}, [locale]);
}

export default useDayJsInitialization;
